module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kk-Lc.901ce1f0.png";